import { AccionModal } from './../models/modal-select.model';
import { ConfirmComponent } from './../confirm/confirm.component';
import { find, Partial } from 'lodash';
import {
  ColumnaMaestra,
  EstructuraEspecifica,
  ValoresEspecificos,
  FiltroTableMasterGeneral,
  Valores
} from './../models/tabla-maestra.model';
import { BaseControl } from './../dynamic-form/shared/controls/base-control';
import { Component, OnInit, Input, EventEmitter, Output, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RefactoryMasterTableDataService } from './shared/refactory-master-table.data.service';
import { RefactoryMasterTableFormService } from './shared/refactory-master-table.form.service';
import { Static } from '../util/static';
import { Logger, GlobalNotifierService } from '@app/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AccesoMaestra, ValoresMaestraPorDefectoSeletor } from '../models/formulario-dinamico.model';
import { Subject } from 'rxjs';

const log = new Logger('RefactoryMasterTableComponent');

@Component({
  selector: 'iw-refactory-master-table',
  templateUrl: './refactory-master-table.component.html',
  styleUrls: ['./refactory-master-table.component.scss'],
  providers: [
    RefactoryMasterTableDataService,
    RefactoryMasterTableFormService
  ]
})
export class RefactoryMasterTableComponent implements OnInit, OnDestroy {

  // Accion que se esta realizando
  @Input() actionRow = 'Agregar';
  // Define el nombre de la tabla maestra a la que se le desea realizar la accion de modificar o actualizar
  @Input() masterTable = '';
  // Contiene el id de la tabla maestra
  @Input() idMasterTable = 0;
  // Define si la accion a realizar es modificar o actualizar
  @Input() modificar = false;
  // Contiene el registro seleccionado de la tabla
  @Input() registroSeleccionado: Valores;
  // Contiene la configuracion de acceso a las maestras para el control actualmente
  @Input() configMasterAccessControl: Array<AccesoMaestra> = [];
  // Contiene la configuracion de valores por defecto de la maestras para el control actualmente
  @Input() configDefaultValues: ValoresMaestraPorDefectoSeletor[] = [];
  // Contiene los valores or defecto del formulario de la maestra a agregar
  @Input() dataDefaultValueMaster: any;
  // Configura los accesos a las maestras
  @Input() set structureMaster(structure: Array<ColumnaMaestra>) {
    const columns = Static.copyObjet(structure) as Array<ColumnaMaestra>;
    columns.forEach(column => {
      if (typeof column.tipo_campo === 'object' && column.tipo_campo.nombre === 'ngSelect') {
        let configAcces = {
          'agregarInModal': false,
          'eliminarInModal': false,
          'modificarInModal': false
        };
        if (
          this.configMasterAccessControl &&
          this.configMasterAccessControl.length &&
          typeof column.maestra_dependencia === 'object'
        ) {
          const configA = find(this.configMasterAccessControl, {id_maestra: column.maestra_dependencia.id});
          if (configA) {
            configAcces = {
              'agregarInModal': configA.agregar,
              'eliminarInModal': configA.eliminar,
              'modificarInModal': configA.modificar
            };
          }
        }
        column.propiedades['accionesInModal'] = configAcces;
      }
    });
    this._structureMaster = columns;
  }
  // Contiene la estructura de la maestra
  _structureMaster: Array<ColumnaMaestra> = [];
  // Define la clase del boton de los formularios
  claseButton = '';
  // Define el texto de el boton submit de los formularios
  textoButton = '';
  // Define la pregunta del componente de confirmacion
  question = '';
  // Contiene el formulario renderizado
  currentForm: FormGroup;
  // Contiene los templetes de los campos personalizados del formulario
  templatesFomr = {};
  // Contiene la data retornada por los formularios
  formData: any;
  // Clase base de los controles del formulario dinamico
  controls: BaseControl<any>[] = [];
  // Define cuando esta accion una accion
  loadingProcess = false;
  // Mensaje de la ventan de cargando
  messaggeLoading = '';
  // Variables utilizan modal selector
  // Accion que se esta realizando
  actionRowMS = 'Agregar';
  // Define el nombre de la tabla maestra a la que se le desea realizar la accion de modificar o actualizar
  masterTableMS = '';
  // Define si la accion a realizar es modificar o actualizar
  modificarMS = false;
  // Contiene el registro seleccionado de la tabla
  registroSeleccionadoMS: any;
  // Contiene la estructura de la maestra
  structureMasterMS: Array<ColumnaMaestra> = [];
  // Contiene el id de la tabla maestra
  idMasterTableMS = 0;
  // Contiene la data de la accion de la modal
  dataAccionModal: AccionModal;

  // Referencia de la modal
  modalRef: BsModalRef;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Referencia al componente de confirmación de los selectores con modal
  @ViewChild('confirmActionSelectModal') private confirmActionSelectModal: ConfirmComponent;
// Referencia al componente de refactorizacion del formulario de la tabla maestra
  @ViewChild('templateRefactorMasterTable') private templateRefactorMasterTable: TemplateRef<any>;
  // Emite la salida del formulario
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private rmtds: RefactoryMasterTableDataService,
    private rmtfs: RefactoryMasterTableFormService,
    private modalService: BsModalService,
    private gns: GlobalNotifierService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.templatesFomr = {
      ngSelectTpl: this.ngSelectTpl,
    };
    this.dynamicForm();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  get structureMaster(): Array<ColumnaMaestra> {
    return this._structureMaster;
  }

  /**
   * Emite el evento de cierre del componente y inicializa todas las variables
   *
   * @memberof RefactoryMasterTableComponent
   */
  closeComponent() {
    this.actionRow = 'Agregar';
    this.masterTable = '';
    this.idMasterTable = 0;
    this.modificar = false;
    this.registroSeleccionado = null;
    this.structureMaster = [];
    this.claseButton = '';
    this.textoButton = '';
    this.question = '';
    this.currentForm = null;
    this.formData = null;
    this.controls = [];
    this.close.emit(true);
  }

  /**
   * Crea la subcripcion de cambias al formulario de agregacion o modificacion de registro
   *
   * @param {FormGroup} form
   * @memberof RefactoryMasterTableComponent
   */
  formCreate(form: FormGroup) {
    if (form) {
      this.currentForm = form;
      this.structureMaster.forEach(field => {
        this.currentForm.controls[field.id + ' '].valueChanges.subscribe(async value => {
          const fieldsDependence = this.selectDependencia(this.structureMaster, field.alias);
          const data = this.getDataForm(this.currentForm, this.structureMaster);
          if (field.tipo_campo['nombre'] === 'ngSelect' && fieldsDependence) {
            await this.asyncForEach(fieldsDependence, async (fieldF: ColumnaMaestra) => {
              await this.loadingSelectsOptions(fieldF, data);
            });
          }
        });
      });
    }
  }

  /**
   * Funcion de el modal de confirmacion
   *
   * @param {*} [data=null]
   * @memberof RefactoryMasterTableComponent
   */
  confirm(data: any = null) {
    if (data) {
      this.formData = data;
      if (this.modificar) {
        this.question = '¿Realmente desea actualizar el registro?';
      } else {
        this.question = '¿Realmente desea agregar el registro?';
      }
    }
    this.confirmAction.open();
  }

  /**
   * controla la respuesta de la comfirmacion
   *
   * @param {boolean} res
   * @memberof RefactoryMasterTableComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      if (this.formData != null) {
        this.sended(this.formData);
      }
    } else {
      if (this.formData != null) {
        this.formData = null;
      }
    }
  }

  /**
   * Cierra el modal del formulario renderizado de la tabla maestra
   *
   * @param {boolean} [loading=false]
   * @memberof RefactoryMasterTableComponent
   */
  closeModal(loading: boolean = false) {
    this.actionRowMS = 'Agregar';
    this.masterTableMS = '';
    this.modificarMS = false;
    this.registroSeleccionadoMS = null;
    this.structureMasterMS = [];
    this.idMasterTableMS = 0;
    this.modalRef.hide();
    if (loading) {
      if (
        this.dataAccionModal.temporalData['form'] &&
        this.dataAccionModal.temporalData['control']
      ) {
        this.loadingModalSelector(
          this.dataAccionModal.temporalData['control']
        );
      }
    }
    this.dataAccionModal = null;
  }

  /**
   * Controla los eventos de accion del seletor en modal
   *
   * @param {AccionModal} data
   * @memberof RefactoryMasterTableComponent
   */
  async actionSelectModal(data: AccionModal) {
    log.debug(data);
    this.dataAccionModal = data;
    switch (data.accion) {
      case 'eliminar':
        this.confirmActionSelectModal.open();
        break;
      case 'agregar':
        this.actionRowMS = 'Agregar';
        this.masterTableMS = data.temporalData['nombre'];
        this.idMasterTableMS = data.temporalData['id'];
        this.modificarMS = false;
        this.registroSeleccionadoMS = null;
        this.structureMasterMS = data.temporalData['estructura'];
        this.openModalFormMasterTable();
        break;
      case 'actualizar':
        this.loadingProcess = true;
        this.messaggeLoading = 'Cargando el registro...';
        this.actionRowMS = 'Modificar';
        this.masterTableMS = data.temporalData['nombre'];
        this.idMasterTableMS = data.temporalData['id'];
        this.modificarMS = true;
        this.registroSeleccionadoMS = await this.rmtds.getInformationDynamicTableMaster(
          data.registroSeleccionado['id']
        ).catch(err => this.loadingProcess = false);
        this.structureMasterMS = data.temporalData['estructura'];
        this.openModalFormMasterTable();
        this.loadingProcess = false;
        break;
    }
  }

  /**
   * Elimina el regitro seleccionado
   *
   * @param {boolean} res
   * @memberof RefactoryMasterTableComponent
   */
  async deleteRowSelectModal(res: boolean) {
    if (res) {
      switch (this.dataAccionModal.accion) {
        case 'eliminar':
          const idregistro = this.dataAccionModal.registroSeleccionado['id'];
          this.rmtds.deleteInformationDynamicTableMaster(idregistro).subscribe(async resp => {
            if (resp) {
              if (
                this.dataAccionModal.temporalData['form'] &&
                this.dataAccionModal.temporalData['control']
              ) {
                this.loadingModalSelector(
                  this.dataAccionModal.temporalData['control']
                );
              }
              this.dataAccionModal = null;
            } else {
              log.debug('No se pudo eliminar el registro.');
            }
          });
          break;
      }
    }
  }

  /**
   * Consulta todas las columnas que dependen de la columna
   *
   * @private
   * @param {ColumnaMaestra[]} fields
   * @param {string} nameControl
   * @returns {ColumnaMaestra[]}
   * @memberof RefactoryMasterTableComponent
   */
  private selectDependencia(fields: ColumnaMaestra[], nameControl: string): ColumnaMaestra[] {
    const fieldsDependenci: ColumnaMaestra[] = [];
    fields.forEach(field => {
      if (field.validaciones && field.validaciones.filtros && field.validaciones.filtros.length) {
        const controlContent = find(field.validaciones.filtros, {field: nameControl});
        if (controlContent) {
          fieldsDependenci.push(field);
        }
      }
    });
    return fieldsDependenci;
  }

  /**
   * Retorna la informacion ingresada en el formulario mapiado en json con la estructura de la maestra
   *
   * @private
   * @param {FormGroup} formData
   * @param {ColumnaMaestra[]} structure
   * @returns {Object}
   * @memberof RefactoryMasterTableComponent
   */
  private getDataForm(formData: FormGroup, structure: ColumnaMaestra[]): Object {
    const data = {};
    structure.forEach(field => {
      let value: any;
      if (
        formData && formData.controls &&
        typeof field.tipo_campo === 'object' &&
        field.tipo_campo.nombre !== 'checkbox' &&
        field.tipo_campo.nombre !== 'coordenadas'
      ) {
        if (formData.controls[field.id + ' ']) {
          value = formData.controls[field.id + ' '].value;
        }
      }
      if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
        value = false;
        if (formData && formData.controls) {
          if (formData.controls[field.id + ' '].value) {
            value = formData.controls[field.id + ' '].value;
          }
        }
        if (formData.controls.hasOwnProperty(field.id + ' ')) {
          data[field.id + ' '] = value;
        }
      } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'date-time-picker') {
        data[field.id + ' '] = value;
      } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'ngSelect') {
        data[field.id + ' '] = value;
      } else if (formData.controls[field.id + ' ']) {
        data[field.id + ' '] = value;
      }
    });
    return data;
  }

  /**
   * Esta funcion renderiza los formularios dependiendo de la opcion seleccionada en el combo principal de las tablas
   * maestras dectetando si se desea modificar o ingresar
   *
   * @private
   * @memberof RefactoryMasterTableComponent
   */
  private async dynamicForm() {
    let objectModel: any;
    if (this.modificar) {
      objectModel = this.registroSeleccionado.datos;
      this.claseButton = 'btn-warning';
      this.textoButton = 'Modificar';
    } else {
      if (this.dataDefaultValueMaster && Object.keys(this.dataDefaultValueMaster)) {
        objectModel = this.dataDefaultValueMaster;
      }
      this.claseButton = 'btn-success';
      this.textoButton = 'Agregar';
    }
    if (this.structureMaster && this.structureMaster.length) {
      await this.asyncForEach(this.structureMaster, async (field: ColumnaMaestra) => {
        if (this.configDefaultValues && this.configDefaultValues.length) {
          const config = find(this.configDefaultValues, {apply: true, columna: field.id});
          if (config) {
            field.propiedades['redonly'] = config.bloquear;
          }
        }
        await this.loadingSelectsOptions(field, objectModel, false);
      });
      this.controls = this.rmtfs.getFieldsDynamicTableStructure(
        this.structureMaster,
        this.templatesFomr,
        objectModel
      );
      this.structureMaster.forEach(field => {
        const ctrl = find(this.controls[0]['controls'], {key: field.id + ' '});
        if (ctrl) {
          if (this.currentForm && this.currentForm.controls[field.id + ' ']) {
            this.currentForm.controls[field.id + ' '].setValue(ctrl['value']);
          }
        }
      });
    }
  }

  /**
   * Refresca las opciones de los selects
   *
   * @private
   * @param {ColumnaMaestra} field
   * @param {*} [data]
   * @param {boolean} [refreshForm=true]
   * @returns {Promise<any>}
   * @memberof RefactoryMasterTableComponent
   */
  private async loadingSelectsOptions(
    field: ColumnaMaestra,
    data?: any,
    refreshForm: boolean = true
  ): Promise<any> {
    return new Promise(async (resolve) => {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        const columnsMaster: Array<{
          key: string,
          value: number
        }> = [];
        let specificEstructure: EstructuraEspecifica;
        let columns: ValoresEspecificos[] = [];
        const filterMaster: FiltroTableMasterGeneral[] = [];

        specificEstructure = {
          maestra: field.maestra_dependencia['id'],
          columnas: [],
          dependencia: []
        };
        // Se crea la estructura de la consulta de las columnas relacionadas a la maestra para el ngselect
        field.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
          const cols = col.split('_');
          const column = Number(cols[0]);
          if (cols.length === 1) {
            if (typeof field.maestra_dependencia === 'object') {
              const structure = find(field.maestra_dependencia.estructura, { id: column });

              if (structure) {
                // field.propiedades['columnas_seleccionadas'].slice(index, 1);
                specificEstructure.columnas.push(column + ' ');
              }
            }
          }
        });
        if (field.propiedades['columnas_seleccionadas'].length) {
          const blockColumns: Array<string[]> = [];
          if (field.propiedades['columnas_seleccionadas']) {
            let columnDependence = '';
            field.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
              const column = col.split('_');
              if (column.length > 1) {
                if (columnDependence !== column[0]) {
                  columnDependence = column[0];
                  const blockColumnsRecolector: Array<string> = [];
                  field.propiedades['columnas_seleccionadas'].forEach((colDep: string, indexDep: number) => {
                    const columnsRef = colDep.split('_');
                    if (columnsRef[0] === columnDependence) {
                      blockColumnsRecolector.push(colDep);
                    }
                  });
                  blockColumns.push(blockColumnsRecolector);
                }
              }
            });
          }
          blockColumns.forEach(columnsSeleted => {
            const history = this.loadingEstructureColumns(
              field.maestra_dependencia['estructura'],
              columnsSeleted,
              Number(columnsSeleted[0].split('_')[0])
            );

            if (history) {
              specificEstructure.dependencia.push(history);
            }
          });
        }
        if (field.validaciones && field.validaciones.filtros && field.validaciones.filtros.length) {
          field.validaciones.filtros.forEach(filter => {
            if (filter.columna) {
              let valorField: any;
              if (filter.field) {
                const control = find(this.structureMaster, {alias: filter.field});
                if (control) {
                  if (data) {
                    valorField = data[control.id + ' '];
                  } else {
                    if (this.currentForm) {
                      valorField = this.currentForm.controls[control.id + ' '].value;
                    }
                  }
                }
              }  else {
                valorField = filter.valor;
              }
              if (!valorField) {
                valorField = '';
              }

              if (filter.operador && (filter.operador === 'LIKE' || filter.operador === 'ILIKE')) {
                valorField = '%' + valorField + '%';
              }

              const cols = filter.columna.split('_');
              if (cols.length && cols.length > 1) {
                if (filter.condicional) {
                  filterMaster.push({
                    maestra: cols[cols.length - 2],
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : '=',
                    condicional: filter.condicional
                  });
                } else {
                  filterMaster.push({
                    maestra: cols[cols.length - 2],
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : '=',
                  });
                }
              } else {
                if (filter.condicional) {
                  filterMaster.push({
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : '=',
                    condicional: filter.condicional
                  });
                } else {
                  filterMaster.push({
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : '=',
                  });
                }
              }
            }
          });
        }
        let validSearch = false;
        if (filterMaster.length === 1) {
          if (filterMaster[0].operador === 'IS NULL' || filterMaster[0].operador === 'IS NOT NULL') {
            validSearch = true;
          } else {
            if (filterMaster[0].valor) {
              validSearch = true;
            }
          }
        } else if (filterMaster.length > 1) {
          validSearch = true;
        } else if (!filterMaster.length) {
          validSearch = true;
        }
        if (validSearch) {
          columns = await this.rmtds.getColumnsSpecificMasterTable(specificEstructure, filterMaster);
        }
        // se setean los labels a mostrar en el select
        columns.forEach(column => {
          let labelSelect = '';
          field.propiedades['columnas_seleccionadas'].forEach((col: string, index: any) => {
            if (index > 0) {
              labelSelect += ' / ';
            }
            if (column.valores[col]) {
              labelSelect += column.valores[col];
            } else {
              labelSelect += 'No aplica';
            }
          });
          columnsMaster.push({ value: column.id, key: labelSelect });
        });
        if (field.propiedades['tipoSelector'] && field.propiedades['tipoSelector'] === 'EnModal') {
          const dataModalSelector: Array<any> = [];
            columns.forEach(row => {
              const d = Static.copyObjet(row.valores);
              d['id'] = row.id;
              dataModalSelector.push(d);
            });
            field.propiedades['dataSelectorModal'] = dataModalSelector;
        }
        field.propiedades['options'] = columnsMaster;
      }
      if (refreshForm) {
        this.controls = this.rmtfs.getFieldsDynamicTableStructure(
          this.structureMaster,
          this.templatesFomr,
          data
        );

        const ctrl = find(this.controls[0]['controls'], {key: field.id + ' '});
        if (ctrl) {
          if (this.currentForm && this.currentForm.controls[field.id + ' ']) {
            this.currentForm.controls[field.id + ' '].setValue(ctrl['value']);
          }
        }
      }
      resolve(true);
    });
  }

  /**
   * Ejecuta un for de forma sincronica
   *
   * @private
   * @param {Array<any>} array
   * @param {*} callback
   * @memberof RefactoryMasterTableComponent
   */
  private async asyncForEach(array: Array<any>, callback: any) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
      continue;
    }
  }

  /**
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @private
   * @param {ColumnaMaestra[]} structure
   * @param {Array<string>} columns
   * @param {number} [idDependence=0]
   * @returns {EstructuraEspecifica}
   * @memberof RefactoryMasterTableComponent
   */
  private loadingEstructureColumns(
    structure: ColumnaMaestra[],
    columns: Array<string>,
    idDependence: number = 0
  ): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const cls: Array<string> = [];
    specificEstructure = {
      maestra: null,
      columnas: [],
      dependencia: []
    };

    columns.forEach(el => {
      cls.push(el);
    });

    for (const field of structure) {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        if (idDependence !== 0 && idDependence !== field.id) {
          continue;
        }
        specificEstructure.maestra = field.id + ' ';
        cls.forEach((col: string, index: number) => {
          const cols = col.split('_');
          const column = Number(cols[1]);
          if (cols.length === 2) {
            const dependenc = Number(cols[0]);
            if (typeof field.maestra_dependencia === 'object') {
              const columnField = find(field.maestra_dependencia.estructura, { id: column });
              if (dependenc === field.id) {

                if (columnField) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            }
          } else if (cols.length > 2) {
            const cl = cols.slice(1);
            cls[index] = '';
            cl.forEach((el: any, indexCol: number) => {
              cls[index] += el;

              if (indexCol < (cl.length - 1)) {
                cls[index] += '_';
              }

            });
          }
        });
        if (cls.length) {
          const newLevel = this.loadingEstructureColumns(field.maestra_dependencia['estructura'], cls);
          if (newLevel) {
            specificEstructure.dependencia.push(newLevel);
            break;
          }
        }
      }
    }
    if (specificEstructure.maestra && (specificEstructure.columnas.length || specificEstructure.dependencia.length)) {
      return specificEstructure;
    } else {
      return null;
    }
  }

  /**
   * Esta funcion se encarga de cargar los modelos con la informacion ingresada en los formularios dependiendo
   * de la tabla maestra a la cual se le desea realizar la accion detetando si se ingresa o modifica el registro
   *
   * @private
   * @param {*} data
   * @memberof RefactoryMasterTableComponent
   */
  private sended(data: any) {
    const valid = this.validDataForm(data, this.structureMaster);
    if (valid) {
      if (this.modificar) {
        this.rmtds.updateInformationDynamicTableMaster(this.registroSeleccionado.id, data).subscribe(res => {
          if (res) {
            this.closeComponent();
          }
        });
      } else {
        this.rmtds.addInformationDynamicTableMaster(this.idMasterTable, data).subscribe(res => {
          if (res) {
            this.closeComponent();
          }
        });
      }
    }
  }

  /**
   * Validad la informacion a guardar de la maestra
   *
   * @private
   * @param {*} data
   * @param {ColumnaMaestra[]} form
   * @returns {boolean}
   * @memberof RefactoryMasterTableComponent
   */
  private validDataForm(data: any, form: ColumnaMaestra[]): boolean {
    let valid = true;
    if (form.length) {
      const formulario = this.currentForm;
      for (const field of form) {
        if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'number') {
          if (data[field.id + ' '] !== undefined) {
            data[field.id + ' '] = Number(data[field.id + ' ']);
          }
        } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
          if (data[field.id + ' '] !== undefined) {
            if (
              typeof data[field.id + ' '] !== 'boolean' &&
              (data[field.id + ' '] === 'true' || data[field.id + ' '] === 'false')
            ) {
              switch (data[field.id + ' ']) {
                case 'true':
                  data[field.id + ' '] = true;
                  break;
                default:
                  data[field.id + ' '] = false;
                  break;
              }
            } else {
              data[field.id + ' '] = false;
            }
          } else {
            data[field.id + ' '] = false;
          }
        }
        const hiddenField = this.getHiddenField(this.controls, String(field.id) + ' ');
        if (data[field.id + ' '] === undefined || hiddenField === 1 || hiddenField === -1) {
          if (data[field.id + ' '] === undefined) {
            if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
              if (formulario.controls[field.id + ' '].value) {
                data[field.id + ' '] = formulario && formulario.controls[field.id + ' '].value;
              } else {
                data[field.id + ' '] = false;
              }
            }
          }
          continue;
        } else {
          if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
            if (field.requerido && !formulario.controls[field.id + ' '].disabled) {
              if (!data[field.id + ' ']) {
                this.toastr.warning(
                  'Hay campos requeridos sin llenar, verifique e inténtelo de nuevo',
                  'Información incompleta', {
                    positionClass: 'toast-top-center'
                  }
                );
                formulario.controls[field.id + ' '].setValue(null);
                valid = false;
                break;
              }
            }
          }
        }
      }
    }
    return valid;
  }

  /**
   * Consulta si un campo dentro de un formulario esta oculto
   * 1 = Si
   * 0 = No
   * -1 = Campo no encontrado
   *
   * @private
   * @param {Array<BaseControl<Partial>>} form
   * @param {string} nameField
   * @returns {number}
   * @memberof RefactoryMasterTableComponent
   */
  private getHiddenField(
    form: Array<BaseControl<Partial>>,
    nameField: string
  ): number {
    let hidden = -1;
    form.forEach(field => {
      if (field.controlType !== 'container') {
        if (field.key === nameField) {
          if (field.hiddenCondiction) {
            hidden = 1;
          } else {
            hidden = 0;
          }
        }
      } else {
        hidden = this.getHiddenField(field['controls'], nameField);
      }
    });
    return hidden;
  }

  /**
   * Abre el modal con el formulario renderizado de la tabla maestra
   *
   * @private
   * @memberof RefactoryMasterTableComponent
   */
  private openModalFormMasterTable() {
    this.modalRef = this.modalService.show(
      this.templateRefactorMasterTable,
        {
          class: 'modal-lg-personalized',
          backdrop: 'static'
        }
    );
  }

  /**
   * Carga las opciones del modal
   *
   * @private
   * @param {ColumnaMaestra} control
   * @memberof RefactoryMasterTableComponent
   */
  private async loadingModalSelector(control: ColumnaMaestra) {
    await this.loadingSelectsOptions(
      this.dataAccionModal.temporalData['control'],
      this.getDataForm(this.currentForm, this.dataAccionModal.temporalData['form']),
      false
    );

    let dataLoading: Array<any> = [];
    if (control.propiedades['dataSelectorModal']) {
      dataLoading = control.propiedades['dataSelectorModal'];
      log.debug('dataLoading', dataLoading);
    }
    this.gns.set<any>({
      source: 'RefactoryMasterTableComponent',
      destiny: 'ModalSelectComponent-' + control.id + ' ',
      action: 'loadingData',
      eventTriggered: 'click',
      data: <any> dataLoading
    }, true);
    this.dataAccionModal = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/refactory-master-table/refactory-master-table.component.ts